import React from 'react';
import { Routes, Route } from 'react-router-dom';

import { useLanguageInitializer } from './hooks';

import CapWidget from './pages/cap';
import Confirm from './pages/confirm/Confirm';
import Status from './pages/status/Status';
import NotFound from './pages/notFound';

const Router: React.FC = (): JSX.Element => {
  useLanguageInitializer();

  return (
    <>
      <Routes>
        {/* CAP Payment - with form (POST auto, PATCH on button click) */}
        <Route
          path="/cap"
          element={<Confirm />}
        />
        
        {/* CAP Payment Widget - direct widget (POST + PATCH auto) */}
        <Route
          path="/cap-widget"
          element={<CapWidget />}
        />

        {/* Status page - payment status display */}
        <Route
          path="/cap-status"
          element={<Status />}
        />

        {/* Default route */}
        <Route
          path="/"
          element={<Confirm />}
        />

        {/* 404 */}
        <Route
          path="*"
          element={<NotFound />}
        />
      </Routes>
    </>
  );
};

export default Router;
